module.exports = __webpack_public_path__ + "static/img/sys_parking.67bf26c8.png";